module.exports = __webpack_public_path__ + "static/img/set_juicies.69e86e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/shop/set_juicies.png
// module id = 1kLN
// module chunks = 1